<div class="container-fluid section py-3">
    <div class="row">
        <div class="col-sm-6 col-lg-12 col-xl-6">
            <div class="d-flex flex-column">
                <span class="header">My calendar</span>
                <generic-calendar [appointmentDates]='appointmentsBackup' [dueDates]='dueDates'
                (dateSelected)="onSelect($event)" (monthChange)="getAppointmentsByMonth($event)"></generic-calendar>
            </div>
        </div>
        <div class="col-sm-6 col-lg-12 col-xl-6 divider mt-3 mt-sm-0 mt-lg-3 mt-xl-0 pt-3 pt-sm-0 pt-lg-3 pt-xl-0">
            <div class="d-flex flex-column">
                <div class="d-flex flex-row justify-content-between">
                    <span class="title mr-2">{{selectedDate | date:'EEE dd MMMM, yyyy'}}</span>
                    <button class="btn btn-theme" data-toggle="modal" data-target="#add-appointment"
                        *ngIf="appointments" [disabled]="addAppointmentBtn">
                        <img src="../../../../../../assets/Images/add_circle.svg" class="mr-2">Add Appointment
                    </button>
                </div>
                <div *ngIf="appointments.length">
                    <span class="section-text mt-2">Appointment with</span>
                    <div class="sub-section py-2 px-3 my-2" *ngFor="let appointment of appointments; let i = index">
                        <div class="d-flex flex-row">
                            <img class="profile-img" *ngIf="appointment.forMum[0].profileImage"
                                [src]="appointment.forMum[0].profileImage">
                            <img class="profile-img" *ngIf="!appointment.forMum[0].profileImage"
                                src="../../../../../../assets/Images/pro-pic.png">
                            <div class="d-flex flex-column flex-grow-1">
                                <span class="title ml-3">{{appointment.forMum[0].name}}</span>
                                <span class="section-text ml-3">Due on: {{appointment.forMum[0].dueDate | date:'EEE dd
                                    MMM'}}</span>
                            </div>
                            <div class="fas mt-3 collapsed" data-toggle="collapse"
                                [attr.data-target]="'#collapse-bk-' + i"></div>
                        </div>
                        <div [attr.id]="'collapse-bk-' + i" class="collapse">
                            <div class="horizontal-line my-2"></div>
                            <div class="d-flex flex-row mt-3 mb-2">
                                <i class="fas fa-phone icon phone"></i>
                                <span class="section-text ml-3">{{appointment.forMum[0].user[0].userPhonenumber}}</span>
                            </div>
                            <div class="d-flex flex-row my-2">
                                <i class="fas fa-envelope icon"></i>
                                <span class="section-text ml-3">{{appointment.forMum[0].user[0].userEmail}}</span>
                            </div>
                            <div class="d-flex flex-row my-2">
                                <i class="fas fa-map-marker-alt icon pl-1"></i>
                                <span class="section-text ml-3">{{appointment.forMum[0].address}}</span>
                            </div>
                            <div class="horizontal-line my-2"></div>
                            <span class="section-text">{{appointment.description}}</span>
                        </div>
                    </div>
                </div>
                <div class="no-data pt-5" *ngIf="!appointments.length">
                    <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50"
                        width="80" alt="No Appointments">
                    <span>No appointments</span>
                </div>
            </div>
        </div>
    </div>
</div>
<app-appointment-modal [signedUpMum]="signedUpMum" [appointmentDate]="selectedDate"
    (refresh)="refreshData($event)"></app-appointment-modal>
